import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface GameState {
  step: number;
  currentChoose: number;
  level1: string;
  level2: string;
  level3: string;
  level4: string;
  level5: string;
  level6: string;
  level7: string;
  inputValue: string;
  completeImage: string;
}

const initialState: GameState = {
  step: 1,
  currentChoose: 0,
  level1: "",
  level2: "",
  level3: "",
  level4: "",
  level5: "",
  level6: "",
  level7: "",
  inputValue: "",
  completeImage: "",
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCurrentChoose: (state, action: PayloadAction<number>) => {
      state.currentChoose = action.payload;
    },
    setLevel1: (state, action: PayloadAction<string>) => {
      state.level1 = action.payload;
      state.currentChoose = 0;
    },
    setLevel2: (state, action: PayloadAction<string>) => {
      state.level2 = action.payload;
      if (!state.level1) {
        state.level1 = "level1_1";
      }
      state.currentChoose = 0;
    },
    setLevel3: (state, action: PayloadAction<string>) => {
      state.level3 = action.payload;
      state.currentChoose = 0;
    },
    setLevel4: (state, action: PayloadAction<string>) => {
      state.level4 = action.payload;
      state.currentChoose = 0;
    },
    setLevel5: (state, action: PayloadAction<string>) => {
      state.level5 = action.payload;
      state.currentChoose = 0;
    },
    setLevel6: (state, action: PayloadAction<string>) => {
      state.level6 = action.payload;
      state.currentChoose = 0;
    },
    setLevel7: (state, action: PayloadAction<string>) => {
      state.level7 = action.payload;
    },
    changeInput: (state, action: PayloadAction<string>) => {
      state.inputValue = action.payload;
    },
    setCompleteImage: (state, action: PayloadAction<string>) => {
      state.completeImage = action.payload;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    resetAll: (state) => {
      state.step = 2;
      state.currentChoose = 0;
      state.level1 = "";
      state.level2 = "";
      state.level3 = "";
      state.level4 = "";
      state.level5 = "";
      state.level6 = "";
      state.level7 = "";
      state.inputValue = "";
      state.completeImage = "";
    },
  },
});

export const {
  setCurrentChoose,
  setLevel1,
  setLevel2,
  setLevel3,
  setLevel4,
  setLevel5,
  setLevel6,
  setLevel7,
  changeInput,
  setCompleteImage,
  setStep,
  resetAll,
} = gameSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const state = (state: RootState) => state.game;

export const canComplete = (state: RootState) =>
  !!(
    state.game.level1 &&
    state.game.level2 &&
    state.game.level3 &&
    state.game.level4 &&
    state.game.level5 &&
    state.game.level6 &&
    state.game.inputValue.length <= 5
  );

export default gameSlice.reducer;
